import { createContext, useContext } from "react";

export const ChatBadgeContext = createContext({ unread: 0, refresh: () => {} });
export const useChatBadge = () => useContext(ChatBadgeContext);
